const EVENT_ADD_PAYMENT_INFO = 'event-add-payment-info';

const addPaymentInfoEventTrigger = () => {
	const checkoutStep = document.querySelector('[data-ec-checkout-step]');
	if (checkoutStep && checkoutStep.dataset.ecCheckoutStep == 2) {
		const event = new CustomEvent(EVENT_ADD_PAYMENT_INFO);
		document.dispatchEvent(event);
	}
};

export {EVENT_ADD_PAYMENT_INFO, addPaymentInfoEventTrigger};